import { SxStyles } from '../../../../types';
import theme from '../../../../theme';
import { getResponsiveSize } from '../../../../utils';

export const buzzerDetailsStyles: SxStyles = {
  buzzerDetails: {
    '& .MuiBox-root': {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    '& .label': {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fs14,
      color: theme.palette.mainControls?.activeText,
    },
    '& .active-label': {
      opacity: 0.5,
    },
  },
};
